import { bikelanesPresenceColors } from '@/components/regionen/pageRegionSlug/mapData/mapDataSubcategories/subcat_bikelanes_plus_presence.const'
import { getDescriptionForInspectorTag } from '@/data/topicDocs/runtime'
import {
  tagsTableCompositRowClass,
  tagsTableCompositSubLabelCellClass,
  tagsTableCompositSubRowHeaderClass,
  tagsTableCompositSubValueCellClass,
  tagsTableCompositTableClass,
} from '../tagsTableLayout'
import { TagsTableRowFrame } from '../TagsTableRow'
import { ConditionalFormattedValue } from '../translations/ConditionalFormattedValue'
import { ValueDisclosure, ValueDisclosureButton, ValueDisclosurePanel } from '../ValueDisclosure'
import type { CompositTableRow } from './types'

const CompositRoadBikelanesTableValue = ({
  label,
  tagKey,
  tagValue,
}: {
  label: string
  tagKey: 'bikelane_left' | 'bikelane_self' | 'bikelane_right'
  tagValue: string
}) => {
  // All other values (that are not in the array above) are the bikelane-category values
  // which are translated in `ALL-category=*`. To access them, we overwrite the `tagKey`.
  const hasPresenceValue = ['not_expected', 'data_no', 'missing', 'assumed_no'].includes(tagValue)
  const hasSpecificInfrastructureValue = !hasPresenceValue
  const description = getDescriptionForInspectorTag('atlas_roads', tagKey, tagValue)
  const hasDescription = Boolean(description)
  const hasDisclosureBody = hasDescription || hasSpecificInfrastructureValue

  return (
    <ValueDisclosure>
      <div className={tagsTableCompositSubRowHeaderClass}>
        <div className={tagsTableCompositSubLabelCellClass}>{label}</div>
        <div className={tagsTableCompositSubValueCellClass}>
          <ValueDisclosureButton hasBody={hasDisclosureBody}>
            <div className="flex items-center justify-between gap-2">
              <ConditionalFormattedValue
                sourceId="atlas_roads"
                tagKey="bikelane_SIDE"
                tagValue={hasSpecificInfrastructureValue ? 'data_present' : tagValue}
              />

              <div
                className="size-4 flex-none rounded-full"
                style={{
                  backgroundColor: hasSpecificInfrastructureValue
                    ? bikelanesPresenceColors.data_present
                    : bikelanesPresenceColors[tagValue as keyof typeof bikelanesPresenceColors],
                }}
              />
            </div>
          </ValueDisclosureButton>
        </div>
      </div>
      <ValueDisclosurePanel>
        {hasDescription && <p>{description}</p>}
        {/* Show the bicycle `category` if the infrastructure is specific */}
        {hasSpecificInfrastructureValue && (
          <ConditionalFormattedValue sourceId="atlas_roads" tagKey="category" tagValue={tagValue} />
        )}
      </ValueDisclosurePanel>
    </ValueDisclosure>
  )
}

export const tableKeyRoadBikelanes = 'composit_road_bikelanes'
export const TagsTableRowCompositRoadBikelanes = ({
  sourceId: _hard_coded_atlas_roads,
  properties,
}: CompositTableRow) => {
  // Only show when one of those keys is present
  if (!(properties.bikelane_left || properties.bikelane_right || properties.bikelane_self)) {
    return null
  }

  return (
    <TagsTableRowFrame label="Radinfrastruktur">
      <div className={tagsTableCompositTableClass}>
        <div className={tagsTableCompositRowClass}>
          <CompositRoadBikelanesTableValue
            label="Links"
            tagKey="bikelane_left"
            tagValue={properties.bikelane_left}
          />
        </div>
        <div className={tagsTableCompositRowClass}>
          <CompositRoadBikelanesTableValue
            label="Fahrbahn"
            tagKey="bikelane_self"
            tagValue={properties.bikelane_self}
          />
        </div>
        <div className={tagsTableCompositRowClass}>
          <CompositRoadBikelanesTableValue
            label="Rechts"
            tagKey="bikelane_right"
            tagValue={properties.bikelane_right}
          />
        </div>
      </div>
      <p className="mt-1 text-xs text-gray-400">
        Angaben in OSM-Linienrichtung. Siehe Doppelpfeil ab Zoom 13.
      </p>
    </TagsTableRowFrame>
  )
}
